import React from 'react'
import Book from '../../assets/book.svg'

import './NoMenus.css'

export const NoMenus = () => (
  <div styleName='noMenus'>
    <Book styleName='noMenuIcon' />
    <p styleName='primary'>Menu not available at this time.</p>
    <p styleName='secondary'>Items cannot be added to cart.</p>
  </div>
)
